import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import "../tokens.stylex.ts";
import { color, font, fontSize, fontWeight, radius, space } from "../tokens.stylex.ts";
export type BadgeTone = "neutral" | "accent" | "success" | "warning" | "error";
export function Badge({
  tone = "neutral",
  dot = false,
  children
}: {
  tone?: BadgeTone;
  dot?: boolean;
  children: ReactNode;
}) {
  return <span {...stylex.props(styles.badge, tones[tone])}>
      {dot ? <span {...stylex.props(styles.dot, dots[tone])} /> : null}
      {children}
    </span>;
}

/** A small colored dot with a label, for dense status columns. */
export function StatusDot({
  tone,
  children
}: {
  tone: BadgeTone;
  children: ReactNode;
}) {
  return <span className="x3nfvp2 x6s0dn4 x1a62zme xxg9qwl xmccgnw xjat59b x187ovcu xuxw1ft">
      <span {...stylex.props(styles.dot, dots[tone])} />
      {children}
    </span>;
}
const styles = {
  badge: {
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kOIVth: "x17d4w8g",
    kZKoxP: "x1qx5ct2",
    kg3NbH: "xlkn9b3",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kaIpWk: "x1y8ptio",
    kMv6JI: "xxg9qwl",
    kGuDYH: "xmccgnw",
    k63SB2: "x14axpdx",
    kb6lSQ: "xjat59b",
    khDVqt: "xuxw1ft",
    kLWn49: "xo5v014",
    $$css: true
  },
  dot: {
    kzqmXN: "x1v4s8kt",
    kZKoxP: "xols6we",
    kaIpWk: "x257jf6",
    kmuXW: "x2lah0s",
    $$css: true
  }
};
const tones = {
  neutral: {
    kWkggS: "x21dbfj",
    kVAM5u: "x4bnxre",
    kMwMTN: "x187ovcu",
    $$css: true
  },
  accent: {
    kWkggS: "x1paulmi",
    kVAM5u: "x1y6q333",
    kMwMTN: "x1rizfjd",
    $$css: true
  },
  success: {
    kWkggS: "x1b947i0",
    kVAM5u: "x1m7v4v1",
    kMwMTN: "x1oux70d",
    $$css: true
  },
  warning: {
    kWkggS: "x24sn52",
    kVAM5u: "xme91cb",
    kMwMTN: "x1cvnich",
    $$css: true
  },
  error: {
    kWkggS: "x1d9afbr",
    kVAM5u: "xspjca9",
    kMwMTN: "x1xcodwn",
    $$css: true
  }
};
const dots = {
  neutral: {
    kWkggS: "x1badam6",
    $$css: true
  },
  accent: {
    kWkggS: "xo3mcg6",
    $$css: true
  },
  success: {
    kWkggS: "xiltt8s",
    $$css: true
  },
  warning: {
    kWkggS: "x1myhf6y",
    $$css: true
  },
  error: {
    kWkggS: "x1dobq8r",
    $$css: true
  }
};